import React from 'react'

import PropTypes from 'prop-types'

import { makeStyles, Chip } from '@material-ui/core'
import { Clear } from '@material-ui/icons'

import styles from './ChipIas.styles'

const useStyles = makeStyles(styles)

const EllipsisText = ({ children }) => {
  return (
    <div
      style={{
        whiteSpace: 'wrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: 100,
      }}
    >
      {children}
    </div>
  )
}
EllipsisText.propTypes = {
  children: PropTypes.node.isRequired,
}

function ChipIas({ label, ellipsis, handleDelete, isEditing, teacherDiscipline }) {
  const classes = useStyles()
  return !teacherDiscipline ? (
    <Chip
      disabled={isEditing && isEditing === true}
      className={classes.chip}
      deleteIcon={<Clear className={classes.icon} />}
      onDelete={handleDelete}
      label={ellipsis ? <EllipsisText>{label}</EllipsisText> : label}
      {...ellipsis}
    />
  ) : (
    <Chip
      disabled={isEditing && isEditing === true}
      className={classes.chip}
      deleteIcon={<Clear className={classes.icon} />}
      onDelete={handleDelete}
      label={label}
      style={{
        backgroundColor: '#B1E9FF',
        color: 'black',
        border: 'none',
        maxWidth: '300px',
        marginBottom: 8,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
      {...ellipsis}
    />
  )
}

ChipIas.defaultProps = {
  ellipsis: true,
  handleDelete: undefined,
}

ChipIas.propTypes = {
  ellipsis: PropTypes.bool,
  handleDelete: PropTypes.func,
  label: PropTypes.string.isRequired,
}
export default React.memo(ChipIas)
